module.exports = __webpack_public_path__ + "static/img/h5-1.365dfa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h5-1.png
// module id = 1275
// module chunks = 1